export const PRIMARY = "#1DA1F2";
export const OVERLAY_SECONDARY = "#134166d9";

export const BLACK = "#14171A";

export const DARK1 = "#657786";
export const DARK2 = "#AAB8C2";

export const LIGHT1 = "#E1E8ED";
export const LIGHT2 = "#F5F8FA";

export const WHITE = "#FFFFFF";

export const OVERLAY = "#1da1f2bf";
